import React, { ReactElement } from 'react';

import { TabItemProps } from './types';

const TabItem = ({ children, eventKey, activeKey }: TabItemProps): ReactElement =>
  eventKey === activeKey && <div className="hmt-tab-item">{children}</div>;

export default TabItem;
